import React from "react";
import styles from "./ArticleElement.module.css";
import { navigate } from "gatsby"
import {getShareURL, selectImageUrl} from "../../helpers/helpers"

const VIDEO_COLOR_MAPPING = {
    "in-conversation" : "#ff571d",
    "judges-panel": "#245eff",
    "behind-the-work": "#27c168"
}

const getVideoColor = (category) => {
    if (category in VIDEO_COLOR_MAPPING) {
        return VIDEO_COLOR_MAPPING[category]
    }
    return "#ff571d"
}

const ArticleElement = (props) => {
    const REPORT_COLOR = props.item.themeColour ? props.item.themeColour : "#e5e5e5"
    const VIDEO_COLOR = getVideoColor(props.item.pageCategory)
    const handleClick = () => {
        navigate(getShareURL('article', props.item.pageCategory, props.item.slug, true) + (props.backRef ? '?backRef=' + props.backRef : ''))
    }
    const bgColor = props.backgroundColor ? props.backgroundColor : (props.item.pageType === "video" ? VIDEO_COLOR : REPORT_COLOR)
    const ctaTitle = props.quote ? props.item.ctaQuote : props.item.ctaTitle
    const ctaSubtitle = props.quote ? props.item.ctaQuoteSubtitle : props.item.subtitle
    const images = props.overwriteImages ? props.overwriteImages : props.item.images

    return (
        <div onClick={props.openModal ? undefined : () => handleClick()} className={[styles.ArticleElement,
                props.type === "related" ? styles.relatedArticle : "",
                props.type === "themeReport" ? styles.themeReport : "",
                props.type === "inMemoriam" ? styles.inMemoriam : "",
                props.type === "grid" ? styles.gridArticle : "",
                props.type === "articleGrid" ? styles.articleGridItem : "",
                props.type === "carouselItem" ? styles.carouselItem : "",
                props.item.pageType === "video" ? styles.videoArticle : "",
                props.quote ? styles.quoteArticle : "",
                props.extraClass
            ].join(" ")}
            style={props.style ? props.style : {backgroundColor: bgColor}}
        >
            {props.item.pageType === "video" && props.item.images &&
                <div className={[styles.topWrapper, styles.videoWrapper].join(' ')}>
                    <div className={styles.videoSymbol} style={props.style ? props.style : {borderLeftColor: VIDEO_COLOR }}/>
                    {images &&
                        <picture>
                            <source media="(min-width:768px)" srcSet={selectImageUrl(images, 'large')} />
                            <img src={selectImageUrl(images, 'small')} alt={props.item.title} />
                        </picture>
                    }
                </div>
            }
            <div className={styles.middleWrapper} style={props.style ? props.style : {backgroundColor: bgColor}}>
                <h2 className={[styles.Title, props.titleClass].join(" ")}>{ctaTitle}</h2>
                {props.item.ctaSubtitle &&  props.item.ctaSubtitle !== "" && props.type === "grid" &&
                    <h3 className={styles.Subtitle}>{ctaSubtitle}</h3>
                }
                {props.type === "inMemoriam" &&
                    <p className={styles.Description}>{props.item.metaDescription}</p>
                }
                {props.type === "themeReport" &&
                    <p className={styles.Description}>{props.item.ctaSubtitle}</p>
                }
                {props.type === "inMemoriam" &&
                    <span className={[styles.Cta, "cta"].join(' ')}>
                        {props.item.ctaLinkText}
                    </span>
                }
            </div>
            <div className={styles.bottomWrapper}>
                {props.type !== "themeReport" && props.type !== "inMemoriam" &&
                    <span className={[styles.Cta, "cta", props.item.pageType === "video" && props.type === "grid" ? "d-none d-md-inline" : ""].join(' ')}>
                        {props.item.ctaLinkText}
                    </span>
                }
                {(props.type === "themeReport" || props.type === "inMemoriam" || props.type === "related") && props.item.pageType !== "video" && images &&
                    <picture>
                        <source media="(min-width:768px)" srcSet={selectImageUrl(images, 'large')} />
                        <img src={selectImageUrl(images, 'small')} alt={props.item.title} />
                    </picture>
                }
            </div>
            {props.type === "themeReport" &&
                <div className={[styles.Cta, "cta"].join(' ')} style={props.style ? props.style : {backgroundColor: bgColor}}>
                    {props.item.ctaLinkText}
                </div>
            }
        </div>
    )
}

export default ArticleElement;